Service = App.loadClass 'core::Angular/Service'

class exports.IrrigationDetails extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getMethods: () ->
        return @http.post 'backend/grower/layers/management-zones/get-irrigation-methods'

    getWaterSources: () ->
        return @http.get 'backend/grower/layers/management-zones/water-sources'

    getSources: () ->
        return @http.post "backend/grower/layers/management-zones/get-energy-sources"

    save: (details) ->
        return @http.post "backend/grower/layers/management-zones/save-details", { details }

    load: (layer) ->
        return @http.post "backend/grower/layers/management-zones/#{layer}/load-details"
